import { post } from 'app/utils/axios/kheti'

const postFarmerProducts = async (
  farmerId: string,
  cropId: string,
  productIds: string[],
) => {
  return post(`/farmer-360/v1/farmer/${farmerId}/crop/${cropId}/products`, {
    product_ids: productIds,
  })
}

export default postFarmerProducts
